import { Button } from './ui/button';
import { RotateCcw } from 'lucide-react';

interface GameControlsProps {
  timerRunning: boolean;
  hints: number;
  onStartPause: () => void;
  onValidate: () => void;
  onHint: () => void;
  onReset: () => void;
}

export function GameControls({ timerRunning, hints, onStartPause, onValidate, onHint, onReset }: GameControlsProps) {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-6">
      <Button onClick={onStartPause} size="lg">
        {timerRunning ? '⏸ Pauza' : '▶ Start'}
      </Button>
      <Button variant="outline" size="lg" onClick={onValidate}>
        ✓ Sprawdź
      </Button>
      <Button variant="outline" size="lg" onClick={onHint} disabled={hints <= 0}>
        💡 Podpowiedź ({hints})
      </Button>
      <Button variant="ghost" size="lg" onClick={onReset}>
        <RotateCcw className="w-4 h-4" />
      </Button>
    </div>
  );
}
